module.exports = __webpack_public_path__ + "img/16.8e29b02f.svg";